import WaterlooHeroSection from "./components/HeroSection";
import WaterlooStickyNav from "./components/StickyNav";
import WaterlooProcessingTimeSection from "./components/ProcessingTimeSection";
import WaterlooServicesSection from "./components/ServicesSection";
import WaterlooLocalAreaSection from "./components/LocalAreaSection";
import WaterlooTestimonialsSection from "./components/TestimonialsSection";
import WaterlooAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WaterlooComparisonSection from "./components/ComparisonSection";
import WaterlooMistakesSection from "./components/MistakesSection";
import WaterlooHowItWorksSection from "./components/HowItWorksSection";
import WaterlooFAQSection, { faqs } from "./components/FAQSection";
import WaterlooHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WaterlooFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function WaterlooPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Waterloo"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/waterloo-ia"
        title="Emergency Passport Waterloo, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Waterloo, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Black Hawk County, Cedar Falls, UNI students, John Deere employees, and Northeast Iowa families."
        geoPlacename="Waterloo, Iowa"
        geoPosition="42.4928;-92.3426"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
      />
      <WaterlooHeroSection />
      <WaterlooStickyNav />
      <WaterlooProcessingTimeSection />
      <WaterlooLocalAreaSection />
      <WaterlooServicesSection />
      <WaterlooTestimonialsSection />
      <WaterlooAcceptanceFacilitiesSection />
      <WaterlooComparisonSection />
      <WaterlooMistakesSection />
      <WaterlooHowItWorksSection />
      <WaterlooFAQSection />
      <WaterlooHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/waterloo-ia" state="IA" />
      <WaterlooFinalCTA />
    </div>
  );
}